module.exports = __webpack_public_path__ + "img/扫码枪.6f47d725.png";